import { DialogActions, DialogContent, DialogTitle, FormControl, Icon, TextField } from '@mui/material';
import CustomDialog from 'components/custom/CustomDialog';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import { useSnackbarCustom } from 'hooks/useSnackCustom';
import HeaderOuBannerDependendoDaInterpretacaoH1 from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import { useEffect, useRef, useState } from 'react';

type Props = {
  open: boolean;
  onCloseHistoricoDialog: () => void;
  getPreviusObs: () => (string | null | undefined | Promise<string | null | undefined>);
  dispatchObs: (obs: string) => void;
};

const initialState = {
  observacao: ''
};

const ObservacaoDialog = (props: Props) => {

  const [localState, setLocalState] = useState(initialState);
  const { addSuccess } = useSnackbarCustom();
  const obsIptRef = useRef<HTMLInputElement>(null);

  const handleClose = () => {
    props.onCloseHistoricoDialog();
  };

  const handleConfirm = () => {
    props.dispatchObs(localState.observacao);
    addSuccess({
      id: 'observacao-salva-com-sucesso',
      message: 'Observação salva com sucesso!',
      closeable: true,
      hideDuration: 3000,
      preventDuplicate: true,
    });
    handleClose();
  };

  useEffect(() => {
    if (!props.open) return;
    setObsFromProps();
    resetFocus();
    //eslint-disable-next-line
  }, [props.open]);

  const resetFocus = () => {
    setTimeout(() => {
      obsIptRef.current?.focus();
    },);
  };

  const setObsFromProps = async () => {
    const observacao = await Promise.resolve(props.getPreviusObs()) ?? '';
    setLocalState(prev => ({ ...prev, observacao }));
  };

  return (
    <CustomDialog
      open={props.open}
      fullWidth
      onClose={handleClose}
      maxWidth={'sm'}
    >

      <DialogTitle style={{ textAlign: "center" }}>
        <HeaderOuBannerDependendoDaInterpretacaoH1
          id='observacao'
          iconClassName='fa-solid fa-pen-to-square'
          label='Observação'
          small
        />
      </DialogTitle>

      <DialogContent
        sx={{
          overflowX: 'hidden',
          paddingTop: '2px !important',
        }}
      >
        <FormControl fullWidth variant="standard" error={false}>
          <TextField
            inputProps={{ id: 'observacao-input', maxLength: 150 }}
            inputRef={obsIptRef}
            multiline
            rows={4}
            value={localState.observacao}
            onChange={(e) => {
              const value = e.target.value;
              setLocalState(prev => ({ ...prev, observacao: value }));
            }}
          />
        </FormControl>
        <small> {localState.observacao.length} de 150</small>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'space-between'
        }}>
        <CustomButton onClick={handleClose} variant="contained" color="error" startIcon={<Icon className='fa-solid fa-xmark' />}>
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleConfirm} id="confirm_button" type="submit" variant="contained" color="success" startIcon={<Icon className='fa-solid fa-check' />}>
          Confirmar
        </CustomButton>
      </DialogActions>

    </CustomDialog>);

};

export default ObservacaoDialog;
